import { useGetExperimentForTenant } from '../hooks'
import { EXPERIMENT_NAME_REMOVE_PACKSIZES_FOR_EXPA } from '../model/EXPERIMENT_NAME_PER_TENANT'
import { EXPERIMENT_VARIATION } from '../model/EXPERIMENT_VARIATION'

import { useRemovePackagesForExpaExperimentIsExpaPresentInUrl } from './components/useIsExpaPresentInUrl'

export const useRemovePacksizesExperimentShouldHideVariants = (): boolean => {
  const removePackSizesExperiment = useGetExperimentForTenant(
    EXPERIMENT_NAME_REMOVE_PACKSIZES_FOR_EXPA,
  )
  const isExpaPresentInUrl =
    useRemovePackagesForExpaExperimentIsExpaPresentInUrl()

  return (
    removePackSizesExperiment.isEnabled &&
    removePackSizesExperiment.variant === EXPERIMENT_VARIATION.V1 &&
    isExpaPresentInUrl
  )
}
